import {evaluate} from "mathjs";

export default {
    methods: {
        //Cal result of express
        calExpressionValue(expression, vars, row) {
            if (expression) {
                let temp = expression + '';
                let available = true;
                for (let item of vars) {
                    let val = this.getNumberValue(row[item]);
                    if (val == null) {
                        available = false;
                        break;
                    }
                    temp = temp.replace('${' + item + '}', val + '');
                }
                if (available) {
                    return evaluate(temp);
                }
            }
            return 0;
        },
        //Find all variables from expression
        findVariablesOfExpression(expression) {
            let i = expression.indexOf('${');
            let tempList = [];
            while (i >= 0 && i < expression.length) {
                let j = expression.indexOf('}', i);
                if (j > -1) {
                    tempList.push(expression.substring(i + 2, j));
                    i = expression.indexOf('${', j);
                } else {
                    break;
                }
            }
            return tempList;
        },
        //检查是否合法
        checkExpression(expression) {
            let vars = this.findVariablesOfExpression(expression);
            let temp = expression + '';
            for (let item of vars) {
                temp = temp.replace('${' + item + '}', '1');
            }
            try {
                evaluate(temp);
            } catch (e) {
                console.warn(e);
                this.$message.error('请检查您的表达式');
                return false;
            }
            console.log(expression);
            return true;
        },
    }
}